import React, { useEffect, useState } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'

import Loader from 'components/ContentBox/Global/Loader/Loader'
import { timeConverter } from 'components/ContentBox/Online-schedule/components/functions'
import styles from './LoadingTeachers.module.scss'
import { superAxiosRequest } from 'axiosApi'
import LineChartTable from './LineChartTable/LineChartTable'
import ContentHeader from 'components/ContentBox/Global/ContentHeader'
import { ExcelRowsParams } from 'components/utils/ExcelExport'
import { observer } from 'mobx-react'
import ExportExcelButton from '../ExportExcelButton/ExportExcelButton'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import useLocalization from 'hooks/useLocalization'
import { useHistory } from 'react-router-dom'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const LoadingTeachers = () => {
  const [isLoading, setIsLoading] = useState({})
  const [groupCatalog, setGroupCatalog] = useState({})
  const history = useHistory()
  const [filter, updateFilter] = useLocalStorageFilter()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore
  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      start_date: 'Start date',
      end_date: 'End date',
    },
  })

  const filterCnf = [
    {
      type: 'select-multi',
      label: 'Локация',
      placeholder: 'Локация',
      values: groupCatalog?.locations,
      sort_key: 'name',
      nameState: 'location',
    },

    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      label: 'Период',
    },
    {
      type: 'select-multi',
      label: 'Уровень группы',
      placeholder: 'Уровень группы',
      values: groupCatalog?.skill_levels,
      sort_key: 'name',
      nameState: 'skill_level',
    },
    {
      type: 'type_selector',
      nameState: 'online',
      label: 'Формат',
      values: [
        { id: 2, name: 'Все группы' },
        { id: 1, name: 'Онлайн' },
        { id: 0, name: 'Офлайн' },
      ],
    },
  ]

  const [myData, setMyData] = useState(null)
  const [date, setDate] = useState({
    from: new Date(new Date().setDate(1)),
    until: new Date(
      new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0),
    ),
  })

  const getMaxHour = (maxMinute) => {
    let maxHour = Math.ceil(maxMinute / 60 / 10) * 10
    return maxHour > 10 ? maxHour : 10
  }

  const sendRequest = (param) => {
    if (param?.date_until && param?.date_from) {
      setIsLoading(true)
      const apiConf = {
        method: 'get',
        link: 'progress_report/teacher_loading',
        params: {
          ...param,
        },
      }

      delete apiConf.params.is_active
      if (apiConf.params.skill_level && apiConf.params.skill_level.length > 0)
        apiConf.params.skill_level = `[${apiConf.params.skill_level.map((item) => item)}]`
      else delete apiConf.params.skill_level
      if (apiConf.params.course_level && apiConf.params.course_level.length > 0)
        apiConf.params.course_level = `[${apiConf.params.course_level.map((item) => item)}]`
      else delete apiConf.params.course_level
      if (apiConf.params.location && apiConf.params.location.length > 0)
        apiConf.params.location = `[${apiConf.params.location.map((item) => item)}]`
      else delete apiConf.params.location
      if (apiConf.params.online === null) delete apiConf.params.online
      superAxiosRequest(apiConf).then((res) => {
        setDate({
          from: new Date(apiConf.params.date_from),
          until: new Date(apiConf.params.date_until),
        })

        const cyrillicPattern = /^[А-Яа-яЁё]/
        const isCyrillic = (fullName) => cyrillicPattern.test(fullName.trim())

        const cyrillicTeachers = []
        const latinTeachers = []

        res.data.result.forEach((teacher) => {
          if (isCyrillic(teacher.full_name)) {
            cyrillicTeachers.push(teacher)
          } else {
            latinTeachers.push(teacher)
          }
        })

        cyrillicTeachers.sort((a, b) =>
          a.full_name.localeCompare(b.full_name, 'ru'),
        )
        latinTeachers.sort((a, b) =>
          a.full_name.localeCompare(b.full_name, 'en'),
        )

        const sortedResult = [...cyrillicTeachers, ...latinTeachers]

        let maxMinute = 0
        sortedResult.forEach((element) => {
          if (element.minutes > maxMinute) maxMinute = element.minutes
        })

        const maxHours = getMaxHour(maxMinute)
        const sectionsLenght = maxHours / 10

        const rowsArray = sortedResult.map((teacher) => {
          const nameEls = teacher.full_name.split(' ')
          let shrtName = ''
          nameEls.forEach((el, id) =>
            id === 0
              ? (shrtName = el)
              : (shrtName = `${shrtName} ${el[0].toUpperCase()}.`),
          )
          return {
            title: shrtName,
            hours: (teacher.minutes / 60).toFixed(2),
            lenght: teacher.minutes / 60 / sectionsLenght,
            user_id: teacher.user_id,
          }
        })

        setMyData({
          settings: {
            maxValue: maxHours,
            interval: sectionsLenght,
          },
          rows: rowsArray,
          total: {
            totalMinutes: res.data.total_minutes,
            totalTeachers: res.data.total_teachers,
          },
        })
        setIsLoading(false)
      })
    }
  }

  const sendFerstReqest = () => {
    superAxiosRequest({
      method: 'get',
      link: 'progress_report/teacher_loading',
    })
      .then(({ data }) => {
        setGroupCatalog(data)
      })
      .catch((e) => console.log(e.message))
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    sendFerstReqest()
  }, [])

  useEffect(() => {
    sendRequest(filter)
  }, [filter])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/reports/loading_teachers') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const downloadExcel = (data) => {
    import('xlsx-js-style').then((XLSX) => {
      const headRow = [
        {
          v: 'Ф.И.О. преподавателя',
          ...ExcelRowsParams.headerRowParam,
        },
        {
          v: 'Количество ас.ч',
          ...ExcelRowsParams.headerRowParam,
        },
      ]

      let tableData = []

      let merges = []
      let wscols = [{ wch: 50 }, { wch: 50 }]

      data.forEach((student) => {
        tableData.push([
          {
            v: `${student.title}`,
            ...ExcelRowsParams.tableRowParam.firstCell,
          },
          {
            v: `${student.hours}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
        ])
      })

      let wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet([headRow, ...tableData])
      ws['!cols'] = wscols
      ws['!merges'] = merges
      XLSX.utils.book_append_sheet(wb, ws, 'List 1')

      XLSX.writeFile(wb, 'Загрузка преподавателей.xlsx')
    })
  }

  const isFilterEmpty = !filterTextValues.length

  return (
    <div className={styles.page}>
      <ContentHeader title='Загрузка преподавателей' />

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          margin: '10px',
        }}
      >
        <SearchBooks
          onSearch={(text) => {
            updateFilter({ ...filter, search: text })
            changeTextValue('search', {
              key: 'search',
              label: 'Search',
              value: text,
            })
          }}
          onClear={() => {
            const { search, ...obj } = filter
            updateFilter(obj)
            setTextValues(
              filterTextValues.filter((field) => field.key !== 'search'),
            )
          }}
          translate={translate}
          placeholder={`Search...`}
          value={filter?.search || ''}
          isFilterEmpty={isFilterEmpty}
        />
        {!!filterTextValues.length && (
          <FilterTextValues
            onDelete={(key) => {
              const { [key]: _, ...obj } = filter
              updateFilter(obj)
            }}
          />
        )}
        {isOpenFilter && (
          <AsideFilter
            translate={translate}
            getFilterParams={updateFilter}
            config={filterCnf}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
          />
        )}
      </div>
      {isLoading ? (
        <Loader />
      ) : myData && myData?.rows?.length > 0 ? (
        <>
          <div style={{ padding: '10px' }}>
            <ExportExcelButton
              data={myData.rows}
              downloadExcel={downloadExcel}
            />
          </div>
          <LineChartTable
            chartData={myData}
            title={`Загрузка преподавателей в часах c ${timeConverter(date.from, 'day')} по ${timeConverter(date.until, 'day')}`}
          />
          <div className={styles.total}>
            Итого часов: {Math.round(myData.total.totalMinutes / 60)} ч.
          </div>
          <div className={styles.total}>
            Итого учителей: {myData.total.totalTeachers} чел.
          </div>
        </>
      ) : (
        <h1 className={styles.noData}>Нет данных для отображения!</h1>
      )}
    </div>
  )
}

export default observer(LoadingTeachers)
